import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const MyCards: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const username = currentUser?.displayName || 'Writer';
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Helper to check if path is active
  const isActive = (path: string) => location.pathname === path;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Preview cards
  const previewCards = [
    { id: 1, name: 'Captain Plot Twist', rarity: 'rare', icon: '🎭', color: '#3B82F6' },
    { id: 2, name: 'Mystery Detective', rarity: 'uncommon', icon: '🔍', color: '#10B981' },
    { id: 3, name: 'Space Explorer', rarity: 'common', icon: '🚀', color: '#9CA3AF' },
    { id: 4, name: 'Dragon Master', rarity: 'epic', icon: '🐉', color: '#A855F7' },
    { id: 5, name: 'Story Wizard', rarity: 'glowing', icon: '🪄', color: '#F59E0B' },
    { id: 6, name: 'Time Traveler', rarity: 'rare', icon: '⏰', color: '#3B82F6' }
  ];

  return (
    <div style={{ 
      display: 'flex', 
      minHeight: '100vh',
      background: '#F8F9FA',
      fontFamily: "'Inter', sans-serif"
    }}>
      
      {/* DESKTOP SIDEBAR - SCROLLS WITH PAGE */}
      {!isMobile && (
        <div style={{
          width: '220px',
          background: 'white',
          borderRight: '1px solid #E0E0E0',
          minHeight: '100vh'
        }}>
          <nav style={{ 
            padding: '24px 0'
          }}>
            {/* DASHBOARD - Back button */}
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                width: '100%',
                padding: '12px 24px',
                background: isActive('/dashboard') ? '#F3F0FF' : 'transparent',
                color: isActive('/dashboard') ? '#6C5CE7' : '#666',
                border: 'none',
                borderLeft: isActive('/dashboard') ? '4px solid #6C5CE7' : '4px solid transparent',
                textAlign: 'left',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (!isActive('/dashboard')) {
                  e.currentTarget.style.background = '#F8F9FA';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/dashboard')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <span style={{ fontSize: '1.2rem' }}>📊</span>
              DASHBOARD
            </button>

            {/* MY STORIES */}
            <button
              onClick={() => navigate('/my-stories')}
              style={{
                width: '100%',
                padding: '12px 24px',
                background: isActive('/my-stories') ? '#F3F0FF' : 'transparent',
                color: isActive('/my-stories') ? '#6C5CE7' : '#666',
                border: 'none',
                borderLeft: isActive('/my-stories') ? '4px solid #6C5CE7' : '4px solid transparent',
                textAlign: 'left',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (!isActive('/my-stories')) {
                  e.currentTarget.style.background = '#F8F9FA';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/my-stories')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <span style={{ fontSize: '1.2rem' }}>📚</span>
              MY STORIES
            </button>
            
            {/* WRITE NEW */}
            <button
              onClick={() => navigate('/write')}
              style={{
                width: '100%',
                padding: '12px 24px',
                background: isActive('/write') || isActive('/regular-book-editor') ? '#F3F0FF' : 'transparent',
                color: isActive('/write') || isActive('/regular-book-editor') ? '#6C5CE7' : '#666',
                border: 'none',
                borderLeft: isActive('/write') || isActive('/regular-book-editor') ? '4px solid #6C5CE7' : '4px solid transparent',
                textAlign: 'left',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (!isActive('/write') && !isActive('/regular-book-editor')) {
                  e.currentTarget.style.background = '#F8F9FA';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/write') && !isActive('/regular-book-editor')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <span style={{ fontSize: '1.2rem' }}>✏️</span>
              WRITE NEW
            </button>
            
            {/* MY CARDS - Current page */}
            <button
              onClick={() => navigate('/my-cards')}
              style={{
                width: '100%',
                padding: '12px 24px',
                background: isActive('/my-cards') ? '#F3F0FF' : 'transparent',
                color: isActive('/my-cards') ? '#6C5CE7' : '#666',
                border: 'none',
                borderLeft: isActive('/my-cards') ? '4px solid #6C5CE7' : '4px solid transparent',
                textAlign: 'left',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (!isActive('/my-cards')) {
                  e.currentTarget.style.background = '#F8F9FA';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/my-cards')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <span style={{ fontSize: '1.2rem' }}>🃏</span>
              MY CARDS
              <span style={{
                marginLeft: 'auto',
                background: '#FFD700',
                color: '#1a1a1a',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '0.7rem',
                fontWeight: '700'
              }}>
                SOON
              </span>
            </button>
          </nav>
        </div>
      )}

      {/* MAIN CONTENT */}
      <div style={{
        flex: 1,
        padding: isMobile ? '20px 16px 80px' : '40px',
        maxWidth: '1100px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        
        {/* Coming Soon Hero */}
        <div style={{
          textAlign: 'center',
          marginBottom: '40px',
          animation: 'fadeIn 0.6s ease-in'
        }}>
          <div style={{
            fontSize: isMobile ? '4rem' : '6rem',
            marginBottom: '20px',
            animation: 'bounce 2s infinite'
          }}>
            🃏
          </div>
          
          <h1 style={{
            fontSize: isMobile ? '2rem' : '3rem',
            fontWeight: '800',
            margin: '0 0 16px 0',
            color: '#1a1a1a',
            background: 'linear-gradient(135deg, #6C5CE7, #A855F7)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            Scrib Cards
          </h1>
          
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #FFD700, #FFA500)',
            color: '#1a1a1a',
            padding: '12px 32px',
            borderRadius: '30px',
            fontSize: isMobile ? '1.2rem' : '1.5rem',
            fontWeight: '800',
            marginBottom: '24px',
            boxShadow: '0 4px 20px rgba(255, 215, 0, 0.4)',
            animation: 'pulse 2s infinite'
          }}>
            COMING SOON! ✨
          </div>

          <p style={{
            fontSize: isMobile ? '1rem' : '1.2rem',
            color: '#666',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Collect awesome character cards as you write! The more you create, the more rare cards you unlock! 🌟
          </p>
        </div>

        {/* Preview Cards Grid */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: isMobile ? '24px' : '40px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          width: '100%',
          maxWidth: '800px'
        }}>
          <h2 style={{
            fontSize: isMobile ? '1.3rem' : '1.6rem',
            fontWeight: '800',
            margin: '0 0 24px 0',
            color: '#1a1a1a',
            textAlign: 'center'
          }}>
            🎁 Sneak Peek at Cards You Can Earn!
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
            gap: isMobile ? '16px' : '20px',
            marginBottom: '32px'
          }}>
            {previewCards.map((card, index) => (
              <div
                key={card.id}
                style={{
                  background: 'linear-gradient(135deg, #F8F9FA, #E9ECEF)',
                  borderRadius: '16px',
                  padding: isMobile ? '20px' : '24px',
                  textAlign: 'center',
                  border: `3px solid ${card.color}`,
                  position: 'relative',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  animation: `fadeInUp 0.6s ease-in ${index * 0.1}s both`,
                  filter: 'grayscale(0.3) opacity(0.8)'
                }}
                onMouseEnter={(e) => {
                  if (!isMobile) {
                    e.currentTarget.style.transform = 'translateY(-8px) scale(1.05)';
                    e.currentTarget.style.boxShadow = `0 12px 24px ${card.color}40`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isMobile) {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }
                }}
              >
                <div style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  background: card.color,
                  color: 'white',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '0.65rem',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                }}>
                  {card.rarity}
                </div>
                
                <div style={{
                  fontSize: isMobile ? '3rem' : '4rem',
                  marginBottom: '12px'
                }}>
                  {card.icon}
                </div>
                
                <div style={{
                  fontSize: isMobile ? '0.85rem' : '0.95rem',
                  fontWeight: '700',
                  color: '#1a1a1a'
                }}>
                  {card.name}
                </div>
              </div>
            ))}
          </div>

          {/* How to Earn Section */}
          <div style={{
            background: 'linear-gradient(135deg, #F3F0FF, #E9E4F7)',
            borderRadius: '16px',
            padding: isMobile ? '20px' : '24px',
            border: '2px solid #6C5CE7'
          }}>
            <h3 style={{
              fontSize: isMobile ? '1.1rem' : '1.2rem',
              fontWeight: '800',
              margin: '0 0 16px 0',
              color: '#6C5CE7',
              textAlign: 'center'
            }}>
              🎯 How to Earn Cards
            </h3>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
              gap: '16px',
              fontSize: isMobile ? '0.85rem' : '0.9rem'
            }}>
              <div style={{
                textAlign: 'center',
                padding: '12px'
              }}>
                <div style={{ fontSize: '2rem', marginBottom: '8px' }}>✍️</div>
                <div style={{ fontWeight: '700', color: '#1a1a1a', marginBottom: '4px' }}>
                  Write Stories
                </div>
                <div style={{ color: '#666', fontSize: '0.85rem' }}>
                  Every story earns you cards!
                </div>
              </div>

              <div style={{
                textAlign: 'center',
                padding: '12px'
              }}>
                <div style={{ fontSize: '2rem', marginBottom: '8px' }}>🏆</div>
                <div style={{ fontWeight: '700', color: '#1a1a1a', marginBottom: '4px' }}>
                  Complete Challenges
                </div>
                <div style={{ color: '#666', fontSize: '0.85rem' }}>
                  Unlock rare cards!
                </div>
              </div>

              <div style={{
                textAlign: 'center',
                padding: '12px'
              }}>
                <div style={{ fontSize: '2rem', marginBottom: '8px' }}>🔥</div>
                <div style={{ fontWeight: '700', color: '#1a1a1a', marginBottom: '4px' }}>
                  Keep Your Streak
                </div>
                <div style={{ color: '#666', fontSize: '0.85rem' }}>
                  Daily writing = epic cards!
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
};

export default MyCards;